// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3T4Sm","bigColWidth":"Table_bigColWidth__3kSx_","biggerColWidth":"Table_biggerColWidth__3YmsE","row":"Table_row__2jqUo","col":"Table_col__3_2Ww"};